import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useNavigate } from 'react-router-dom';


  
function PopupSalesDialog(props) {
  
  const myDomain = "src=\"" + process.env.REACT_APP_BASE_URL;
    const getImagesWithAbsolutePath = (text, absolutePathPrefix) => {
        if (!text) return ''
        const regex =  new RegExp(`(?:src=\"\/*)+(.*?)`, "g")
        return text.replace(regex,  absolutePathPrefix + '/$1')
    }
    const navigate = useNavigate();
    const { onClose, popupText, open, linkTitle, linkUrl, title } = props;
    
  
    
    const handleGotoAnnouncement = () => {
      
      navigate(props.linkUrl)
      onClose('');
    };
    
  
    const handleListItemClick = (value) => {
      onClose(value);
    };
  
    return (
      <Modal show={open} onHide={onClose} size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered >
     
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div dangerouslySetInnerHTML={{__html: getImagesWithAbsolutePath(popupText, myDomain)}}></div>
        </Modal.Body>

        <Modal.Footer> 
        <Button variant="secondary" onClick={onClose}>
            بستن
          </Button>        
         
        </Modal.Footer>
      
    </Modal>
    );
  }
export default PopupSalesDialog;